import React from 'react';
import './VariantToggle.css';

/**
 * Segmented A / B toggle for mobile-first design flows.
 */
const VariantToggle = ({ value, onChange, scoreA, scoreB, recommended }) => (
  <div className="variant-toggle" role="tablist" aria-label="Design variant">
    {['A', 'B'].map((variant) => {
      const score = variant === 'A' ? scoreA : scoreB;
      const isActive = value === variant;
      const isRecommended = recommended === variant;

      return (
        <button
          key={variant}
          type="button"
          role="tab"
          aria-selected={isActive}
          className={`variant-toggle-btn ${isActive ? 'active' : ''} ${isRecommended ? 'recommended' : ''}`}
          onClick={() => onChange(variant)}
        >
          <span className="variant-toggle-label">{variant}</span>
          {score != null && <span className="variant-toggle-score">{score}</span>}
          {isRecommended && <span className="variant-toggle-star" aria-label="Best match">★</span>}
        </button>
      );
    })}
  </div>
);

export default VariantToggle;
